// extracted by mini-css-extract-plugin
export default {"formTextareaBox":"index_formTextareaBox_O4Qp-","formTextarea":"index_formTextarea_xV7JS","formTextareaWord":"index_formTextareaWord_RhwhM","redSize":"index_redSize_iWaBW"};